import { render, staticRenderFns } from "./MaxItemsDisplay.vue?vue&type=template&id=59c50a9a&scoped=true"
import script from "./MaxItemsDisplay.vue?vue&type=script&lang=js"
export * from "./MaxItemsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c50a9a",
  null
  
)

export default component.exports